<template>
  <v-container fluid class="paystatement-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/paystatement/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindPayStatement=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="createPayment">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Pay
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_statements.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/payroll/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Payroll
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="paystatements-table"
              show-select
              single-select
              item-key="_id"
              v-model="data_select"
              sort-desc
              sort-by="paystatementdate"
              :footer-props="footer"
              :headers="header_items"
              :items="data_statements"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteStatement"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Pay Statement?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepaystatement.paystatementnum }} 
                      {{ deletepaystatement.paystatementname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteStatement = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletepaystatement)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="item.employeeimage!=null" size="40">
                  <img v-bind:src="item.employeeimage" alt="">
                </v-avatar>
                <span style="margin-left:15px">{{ item.employeename }} </span>
              </template>
              <template v-slot:item.payments="{ item }">
                <div v-if="item.payments" style="font-size: 10pt;">{{ item.payments.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount.toFixed(2)}`).join('\n') }}</div>
              </template>
              <template v-slot:item.paystatementnum="{ item }">
                <p class="two-line">{{ item.paystatementtype  }} {{ item.paystatementnum  }}</p>
                <p class="two-line">{{ new Date(item.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
              </template>
              <template v-slot:item.payrollnum="{ item }">
                {{ item.payrollnum!=null ? `Payroll #${item.payrollnum}` : ''  }}
              </template>
              <template v-slot:item.paystatementstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.paystatementstatus)"
                  small>
                  {{ item.paystatementstatus }}
                </v-chip>
              </template>
              <template v-slot:item.paystatementnetpay="{ item }">
                {{ item.paystatementnetpay!=null ? item.paystatementnetpay.toLocaleString('en-SG') : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn  v-if="item.paystatementstatus!=='Complete'" icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.paystatementstatus!=='Complete'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  <div>
    <v-dialog
        v-model="isFindPayStatement"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Pay Statements</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    :items="departments.filter(x=>x.departmentstatus=='Active').map(x => {
                              return {text: x.departmentname, value: x._id};
                            })"
                    v-model="find_query.departmentid"
                    label="Department"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    :items="employees.filter(x=>x.employeestatus=='Active'||x.employeestatus=='Contract').map(x => {
                              return {text: x.employeename, value: x._id};
                            })"
                    v-model="find_query.employeeid"
                    label="Employee"
                    required
                    dense
                  ></v-select>
                </v-col>          
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="Statement Num"
                    v-model="find_query.statementnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Bill Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindPayStatement = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetPayStatements"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findPayStatements"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '../../../util/tools';

export default {
  name: 'PayStatementList',
  data() {
    return {
      config,
      snackbar: null,
      isDeleteStatement: false,
      menu_startdate: null,
      menu_enddate: null,
      isFindPayStatement: false,
      deletepaystatement: {},
      find_query: {},
      header_items: [
        { text: 'Num', value: 'paystatementnum', width: '15%' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Payroll', value: 'payrollnum', width: '10%' },
        { text: 'Net Pay', value: 'paystatementnetpay', width: '10%' },
        { text: 'Paid', value: 'payments', width: '15%' },
        { text: 'Status', value: 'paystatementstatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      data_statements: [],
      data_select: [],
      isPayroll: false,
      isPaymentError: false,
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('PayStatement', ['paystatements', 'isReceiving', 'isDeleting', 'idToDelete', 'paystatementsMessage', 'isUpdating']),
    ...mapState('Department', ['departments']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('PayStatement', ["getPayStatementsRequest", "findPayStatementsRequest", "deletePayStatementRequest","updatePayStatementRequest","createPayStatementRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Department', ["getDepartmentsRequest"]),
    getFileName(){
      var d = new Date();
      var name = 'paystatements-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    getJson(){
      let json = this.data_statements.map(statement=>{return {
        statement_num: statement.paystatementnum, 
        statement_date: statement.paystatementdate!=undefined ? new Date(statement.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        period_start: statement.paystatementstartdate!=undefined ? new Date(statement.paystatementstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        period_end: statement.paystatementenddate!=undefined ? new Date(statement.paystatementenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',

        statement_type: statement.paystatementtype,
        statement_name: statement.paystatementname, 
        net_pay: statement.paystatementnetpay,
        deduction: statement.transactions.filter(x=>x.transsubtype=="Deduction").reduce((a, b) => a + (b.transdebit), 0),
      }});
      return json;
    },
    editItem(item) {
      this.$router.push({ name: 'PayStatementEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'PayStatementPrint', params: item })
    },
    checkError(){
      if(this.data_select.length==0) return false;
      if(this.data_select.find(item=>item.payrollid!=null)!=null) return false;
      if(this.data_select.find(item=>item.paystatementstatus=='Completed')!=null) return false;
      return true;
    },
    createPayment(){
      if(!this.checkError()) {
        if(this.data_select.length==0) this.dialogMessage='No Statements selected';
        else this.dialogMessage='The following Bills cannot be deposited:  ' + this.checkBills();
        this.isPaymentError=true; 
        return;
      }
      let bills = Object.assign([], this.data_select);
      let json = {bills: bills, isPayStatements: true};
      json['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentAdd', params: json });
    },
    async deleteItem(item) {
      await this.deletePayStatementRequest(item);
      this.data_statements = Object.assign([], this.paystatements);
      this.isDeleteStatement = false;
    },
    deleteDialog(item) {
      this.isDeleteStatement = true;
      this.deletepaystatement = {
        _id: item._id,
        paystatementnum: item.paystatementnum,
        paystatementname: item.paystatementname,
      }
    },
    async resetPayStatements(){
      this.find_query = {};

    },
    async findPayStatements(){
      this.isFindPayStatement = false;
      if(Object.keys(this.find_query).length==0){
        await this.getPayStatementsRequest();
        this.data_statements = Object.assign([], this.paystatements);
      }
      else{
        
        let result = await this.findPayStatementsRequest(this.find_query);
        this.data_statements = Object.assign([], result);
      }
    },
  },
  async created () {
    if(this.paystatements.length==0) await this.getPayStatementsRequest();
    this.data_statements = Object.assign([], this.paystatements);
    
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
